import { Component, Input, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IdentifierService } from 'merlin-core';
import { UserProfileObject, UserService } from 'merlin-library';
import { CommonService } from 'projects/clinician/src/app/shared/service/common.service';
import { LocalizationService } from 'src/core/utilitites/localization.service';
@Component({
    selector: 'app-enroll-confirmation-dialog',
    templateUrl: 'confirmation-dialog.component.html',
    styleUrls: ['confirmation-dialog.component.scss'],
    standalone: false
})
export class ConfirmationDialogComponent implements OnInit {
    @Input() deviceChange;
    patientName: string;
    firstName: string;
    lastName: string;
    patientId: string;
    //isTTSUser: boolean;
    isDataCorrected: boolean = false;
    deviceInfoText: string;
    disableRadioBtn: boolean = false;
    dataCorrectionKey: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { patient: any; deviceInfo: any;transmissionCount:number;isLeadlessPacemaker:boolean;techSupportDmrOnly:boolean },
        private dialogRef: MatDialogRef<ConfirmationDialogComponent>,
        public identifierService: IdentifierService,
        private localizationService: LocalizationService,
        private commonService: CommonService
    ) {}

    ngOnInit() {
        // this.userService.getUserProfile().subscribe((res: UserProfileObject)=> {
        //     this.isTTSUser = res.userRecordId === 0 && res.impersonatedUser;
        // })

        let { lastName, firstName } = this.data.patient;
        this.firstName = firstName;
        this.lastName = lastName;
        this.patientName = `${lastName} ${firstName}`;
        this.patientId = this.data.patient.patientNum
            ? ' (' +
              this.translate('label.gb.patient_id_prefix') +
              ': ' +
              this.data.patient.patientNum +
              ')'
            : '';
        const devInfo = this.data.deviceInfo;
        this.deviceInfoText = devInfo;
        this.dataCorrectionKey = this.data.isLeadlessPacemaker ? 'msg.gb.data_correction_instr_NA' : 'msg.gb.data_correction_instr';
        this.disableRadioBtn = this.data.transmissionCount > 0 && !this.data.techSupportDmrOnly ;
    }

    cancel() {
        this.isDataCorrected = false;
        this.commonService.setDataCorrectedValue(false);
        this.dialogRef.close({ data: 'cancel' });
    }
    continue() {
        if (
            typeof this.deviceChange !== 'undefined' ||
            this.deviceChange === null
        ) {
            this.dialogRef.close({ data: this.deviceChange });
            this.isDataCorrected = true;
            this.commonService.setDataCorrectedValue(this.isDataCorrected);
        } else {
            this.dialogRef.close({ data: 'cancel' });
        }
    }
    translate(key: string) {
        return this.localizationService.generateLocalizedStr(key, {}, 'html');
    }
    getReasonForChange(key, param1, param2, param3) {
        return this.localizationService.generateLocalizedStr(key, {
            '0': param1 ? param1 : '',
            '1': param2 ? param2 : '',
            '2': param3,
        });
    }
}
